import * as React from 'react';
import classnames from 'classnames'
import { Link } from 'office-ui-fabric-react/lib/Link';
import { debug } from 'util';
import Debugger from '../components/Debugger';

export interface Props {
    campaignID?: string,
    className: string,
    //links?: { [url: string]: string },
    account?: any,
    autoLogin?: (any, string) => string,
    onSignout?: () => void,
}

export const DEFAULT_ACCOUNT_LINKS = {
    "/campaigns/{campaignID}": "Open this campaign's dashboard",
    "/campaigns": "View all your campaigns",

}

export const DEFAULT_HELP_LINKS = {
    "https://mm365.me/tutorials": "View tutorials",
    "https://mm365.me/help": "Open help center",
}
export class State {
    debug: boolean;
}

export default class Wrapper extends React.Component<Props, State> {


    constructor(props, context) {
        super(props, context);
        this.state = {
            debug: false,
        };
    }

    onToggleDebug = (event) => {
        this.setState({
            debug: !this.state.debug
        });
    }


    render() {
        const {
            className,
            account,
            autoLogin,
            onSignout,
        } = this.props;

        const {
            debug
        } = this.state;

        let links = account ? {
            ...DEFAULT_ACCOUNT_LINKS,
            "/account": "Manage your account",
            ...DEFAULT_HELP_LINKS
        } : DEFAULT_HELP_LINKS;



        return (
            <div className={classnames('mm-wrapper', className)}>
                <div className="-row -expand">
                    {this.props.children}
                </div>
                {debug && <div className="-row -expand">
                    <Debugger />
                </div>}
                <div className="-row" style={{ "paddingTop": "1em" }}>
                    {account &&
                        <React.Fragment>
                            <p className="ms-font-m -label -tightpadding"><span className="ms-fontWeight-bold">Account: {account.email}</span></p>
                            <p className="ms-font-s -label"><span className="">{account.plan}</span></p>
                        </React.Fragment>
                    }
                    {!account &&
                        <p className="ms-font-m -label"><span className="ms-fontWeight-semibold">MailMerge365 Links</span></p>}


                    <div className="mm-para">
                        <ul className="-links">
                            {Object.keys(links).filter(key => this.props.campaignID || key.indexOf('{campaignID}') < 0).map(key =>
                                <li key={key}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" href={account && autoLogin(account, key.replace('{campaignID}', this.props.campaignID))}>{links[key]}</Link></li>

                            )}
                            {onSignout &&
                                <li key={'signout'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" onClick={onSignout}>Sign out</Link></li>
                            }
                            {account && account.debug &&
                                <>
                                    <li key={'debug'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" onClick={this.onToggleDebug}>Debug</Link></li>
                                </>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
